<div class="login-wrapper">
    <form [formGroup]="loginForm" autocomplete="on">

        <mat-card>
            <mat-toolbar color="primary" class="top-toolbar">
                <mat-toolbar-row style="padding-left: 20px;">Login</mat-toolbar-row>
            </mat-toolbar>
            <mat-card-content style="padding-top: 20px;">
                <label>Username</label>

                <mat-form-field>
                    <input matInput formControlName="usr_NAME" autocomplete="username" name="username">
                </mat-form-field>
                <label>Password</label>
                <mat-form-field>
                    <div class="password-container">
                        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="usr_PASSWORD"
                            autocomplete="current-password" name="password">
                        <button mat-icon-button type="button" (click)="hidePassword = !hidePassword">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </div>
                </mat-form-field>

                <mat-divider style="margin-bottom: 10px;" *ngIf="showOrgList"></mat-divider>



                <label *ngIf="showOrgList">Organization (optional)</label>

                <mat-form-field appearance="fill" *ngIf="showOrgList">
                    <input matInput formControlName="org_name" [matAutocomplete]="auto"
                        #trigger="matAutocompleteTrigger" />

                    <button *ngIf="showOrgListArrow" mat-icon-button matSuffix type="button">
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>

                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let org of organizationList" [value]="org.org_name">
                            {{ org.org_name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-card-actions>
                    <button mat-fab extended color="primary" (click)="onLogin()" *ngIf="!loggingIn"
                        [disabled]="loginForm.invalid">Login</button>
                    <mat-spinner *ngIf="loggingIn" [diameter]="50"></mat-spinner>
                </mat-card-actions>



            </mat-card-content>

            <mat-toolbar style="margin-top: 20px;" class="bottom-toolbar">
                <mat-toolbar-row>

                </mat-toolbar-row>
            </mat-toolbar>
        </mat-card>


    </form>

</div>